import request from '@/utils/request'

export function presidentMailAdd(data) {
  return request.post('/president-mailbox/add', data);
}

export function presidentMailList(data) {
  return request.post('/president-mailbox/list', data);
}

export function presidentMailModify(data) {
  return request.post('/president-mailbox/modify', data);
}

export function presidentMailDel(data) {
  return request.post('/president-mailbox/delete', data);
}

export function presidentMailReply(data) {
  return request.post('/president-mailbox/reply', data);
}

export function presidentMailUpload(data) {
  return request.post('/president-mailbox/upload', data);
}

export function presidentMailFileList(data) {
  return request.post('/file/president-mailbox-list', data);
}

export function presidentMailFileDel(data) {
  return request.post('/president-mailbox/delete-file', data);
}




// WEBPACK FOOTER //
// ./src/api/presidentMailbox.js